import { render, staticRenderFns } from "./PermitView.vue?vue&type=template&id=582792aa&scoped=true"
import script from "./PermitView.vue?vue&type=script&lang=js"
export * from "./PermitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582792aa",
  null
  
)

export default component.exports